var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"modal-wrap"},[_c('div',{staticClass:"modal"},[_c('header',[_vm._t("header")],2),_c('main',[_vm._t("default")],2),_c('footer',[_vm._t("footer",function(){return [_c('button',{on:{"click":function($event){return _vm.$emit('close')}}},[_vm._v("Close")])]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }